module.exports = __webpack_public_path__ + "img/wxbooty_degenpirates.07587cf.png";